export const SET_IS_FORGOT_PASSWORD_POPUP_OPEN = 'SET_IS_FORGOT_PASSWORD_POPUP_OPEN';
export const SET_IS_FORGOT_PASSWORD_RESULT_POPUP_OPEN = 'SET_IS_FORGOT_PASSWORD_RESULT_POPUP_OPEN';
export const SET_USERNAME = 'SET_USERNAME';
export const FORGOT_PASSWORD = 'FORGOT_PASSWORD';
export const RESEND = 'RESEND';